/* import __COLOCATED_TEMPLATE__ from './sh-tooltip.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

class ShTooltipComponent extends Component {
  @tracked template = null;

  get destinationElement() {
    return document.getElementById('SH-app__template-wormhole');
  }

  get content() {
    return this.template || this.args.tooltip;
  }

  @action
  setTemplate(ref) {
    this.template = ref;
  }
}

export default ShTooltipComponent;
